module.exports = __webpack_public_path__ + "img/SC5-expenses.61589098.png";